import { render, staticRenderFns } from "./DropDownMenu.vue?vue&type=template&id=024ffb4c&scoped=true&"
import script from "./DropDownMenu.vue?vue&type=script&lang=js&"
export * from "./DropDownMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropDownMenu.vue?vue&type=style&index=0&id=024ffb4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ffb4c",
  null
  
)

export default component.exports